var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYiconGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 628,
    height: 861,
    viewBox: "0 0 628 861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.286 686.857L138.498 190.064H272.108L297.01 515.899C297.095 517.01 297.904 517.931 298.995 518.157C300.085 518.383 301.194 517.86 301.714 516.875L466.021 205.312C466.331 204.724 466.394 204.036 466.196 203.4C465.997 202.765 465.554 202.236 464.964 201.928L413.02 174.899L624.328 5.56465L624.746 285.54L570.039 256.912C568.838 256.284 567.356 256.726 566.696 257.91L343.153 658.929L343.15 658.933C318.923 702.593 299.073 738.301 282.258 764.844C265.47 791.343 249.601 811.232 235.101 825.008C221.152 837.8 204.238 846.766 185.606 851.467L185.576 851.475C169.367 855.78 152.711 857.94 135.597 858.373C70.3302 858.373 36.6245 858.155 19.2396 857.937C12.0275 857.846 7.63205 857.756 4.9616 857.682L60.9768 761.247C61.0469 761.247 61.1194 761.246 61.1945 761.245C62.2645 761.233 63.8379 761.216 65.8503 761.196C69.8752 761.155 75.6563 761.1 82.6803 761.045C96.7288 760.936 115.747 760.827 135.628 760.827C135.721 760.827 135.814 760.822 135.907 760.811C139.979 760.355 144.04 759.443 148.087 758.083C160.596 754.023 171.799 746.796 180.328 736.832C189.66 726.067 198.87 710.071 207.149 688.081C207.296 687.691 207.343 687.27 207.286 686.857Z",
    fill: "url(#paint0_linear_1994_114)",
    stroke: "url(#paint1_linear_1994_114)",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1994_114",
    x1: 729.5,
    y1: -108.5,
    x2: -330.5,
    y2: 1227.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616144,
    stopColor: "#8C5800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.190119,
    stopColor: "#EC9D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300052,
    stopColor: "#F4B602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364888,
    stopColor: "#F8C402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450422,
    stopColor: "#EDD072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593792,
    stopColor: "#F8C402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#8C5800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1994_114",
    x1: 811.5,
    y1: -248,
    x2: -600.5,
    y2: 1433.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYiconGold);
export default __webpack_public_path__ + "static/media/yicon-gold.66d8288e78bd1522f027817fd9d79cb4.svg";
export { ForwardRef as ReactComponent };